var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "reMain" },
    [
      _c("RealTitle", {
        attrs: { titleInfo: _vm.titleInfo, backPath: _vm.backPath },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "reMainContent" }, [
        _c(
          "div",
          { staticClass: "reNewsContent" },
          [
            _c("div", { staticClass: "reNewsTitle" }, [
              _vm._v(_vm._s(_vm.newsInfo.newsTitle)),
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "newsDetail" }, [
              _c("div", { staticClass: "newsDetailDate" }, [
                _vm._v("发布时间:" + _vm._s(_vm.newsInfo.createTime)),
              ]),
            ]),
            _vm._v(" "),
            _vm.newsInfo.newsContent !== ""
              ? [
                  _c("div", {
                    staticClass: "newsContent vHtml",
                    domProps: { innerHTML: _vm._s(_vm.newsInfo.newsContent) },
                  }),
                ]
              : _vm._e(),
            _vm._v(" "),
            _vm._l(_vm.uploadFileList, function (file, index) {
              return _c("div", { key: index, staticClass: "accessoryReview" }, [
                _c("div", { staticClass: "viewBox" }, [
                  _c("span", [
                    _c(
                      "a",
                      {
                        staticStyle: { color: "#007eff" },
                        attrs: { target: "_blank" },
                        on: {
                          click: function ($event) {
                            return _vm.download(file.ossOriUrl, file.fileName)
                          },
                        },
                      },
                      [
                        _vm._v(
                          "附件" +
                            _vm._s(index + 1) +
                            "：" +
                            _vm._s(file.fileName)
                        ),
                      ]
                    ),
                  ]),
                ]),
              ])
            }),
            _vm._v(" "),
            _c("div", { staticClass: "op-content" }, [
              _vm.newsInfo.lastId
                ? _c(
                    "div",
                    {
                      staticClass: "prev-page",
                      on: {
                        click: function ($event) {
                          return _vm.changeNews(_vm.newsInfo.lastId)
                        },
                      },
                    },
                    [
                      _c("span", [_vm._v("上一篇：")]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.newsInfo.lastTitle))]),
                    ]
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.newsInfo.nextId
                ? _c(
                    "div",
                    {
                      staticClass: "next-page",
                      on: {
                        click: function ($event) {
                          return _vm.changeNews(_vm.newsInfo.nextId)
                        },
                      },
                    },
                    [
                      _c("span", [_vm._v("下一篇：")]),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.newsInfo.nextTitle))]),
                    ]
                  )
                : _vm._e(),
            ]),
          ],
          2
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }